import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../store/UserSlice/userSlice';
import { clearAuthMe, fetchAuthMe } from '../../store/AuthmeSlice/authmeSlice';
import { checkHiringDateBiggerThanSixMonthes } from "../../libs/generalFunctions";
import usePermissions from '../../customHooks/usePermissions';
import useFetchEvaluationsExcelFile from '../../customHooks/useFetchEvaluationsExcelFile';

import Dropdown from '../Dropdowns/Dropdown/Dropdown';
import NotificationBell from '../NotificationBell/NotificationBell';
import almatin_img from '../../img/almatin_group.png';

import './navbar.scss';


function Navbar({ onIconClick }) {

  const authMeStatus = useSelector(state => state.authme.status);

  const authMe = useSelector(state => state.authme.data);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const sideNavRef = useRef(null);

  const { checkPermissionAndThrow } = usePermissions();

  const { downloadExcelFile } = useFetchEvaluationsExcelFile();

  //===state start here===

  const [openNavIcon, setOpenNavIcon] = useState(false)

  //===state end here===


  //====Event handler start here====

  //to close the navbar when we click outside of it
  function handleClickOutside(event) {
    if (sideNavRef.current && !sideNavRef.current.contains(event.target)) {
      setOpenNavIcon(false);
    }
  }


  const handelLogOut = (e) => {
    // Clear local storage
    dispatch(clearAuthMe())
    dispatch(clearUser());

    const serializedState = localStorage.getItem('state');

    if (serializedState !== null) {
      localStorage.removeItem('state');

    }

    // Dispatch logout action to clear Redux state


    // Navigate to the login page or another page
    navigate('/login');
  }


  //function to return the full emp name 
  const handleGetFullEmpName = () => {
    let fullName = "";
    if (authMe.family_name) {
      fullName = authMe.name + ' ' + authMe.family_name;
    }
    else {
      fullName = authMe.name;
    }

    return fullName;
  }


  const handleExportEvalExcelFile = () => {
    downloadExcelFile();
  }

  //====Event handler end here====




  //===useEffect start here===

  //to close the navbar when we click outside of it
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (authMeStatus === 'idle') {
      dispatch(fetchAuthMe());
    }

  }, [dispatch, authMeStatus]);

  //===useEffect end here===   



  return (
    <div className='navbar'>
      {
        (!authMe.change_password)
          ?
          (
            <div className="navbar_left">

              <div className='big_navbar'>

                {/* <Link to="/emp/whate_insurance" className='nav_links_white itemInside_menu' onClick={()=>{ setOpenNavIcon(!openNavIcon); }} >ماهو التأمين الصحي </Link> */}

                {(checkPermissionAndThrow("create_evaluations") || checkPermissionAndThrow("read_evaluations") || checkPermissionAndThrow("update_evaluations")
                  || checkPermissionAndThrow("read_evaluation_settings") || checkPermissionAndThrow("read_manager_evaluations")
                  || checkPermissionAndThrow("hr_manager") || checkPermissionAndThrow("read_evaluation_manager_statistics")
                  || checkPermissionAndThrow("read_evaluation_statistics") || authMe?.is_manager) &&
                  (

                    <Dropdown
                      buttonText="التقييم"
                      content={
                        <>
                          {(authMe?.is_manager || checkPermissionAndThrow("hr_manager") || checkPermissionAndThrow("read_evaluations")
                            || checkPermissionAndThrow("update_evaluations")) && (
                              <Link to="/emp/eval_emp_manager" className='link_inside_dropdown' ><span dir="rtl"  >التقييم</span></Link>
                            )}

                          {(checkPermissionAndThrow("read_evaluation_statistics")) && (
                            <Link to="/emp/eval_stat_main_page_show" className='link_inside_dropdown' ><span dir="rtl"  >احصائيات تقييم الموظفين</span></Link>
                          )}


                          {(checkPermissionAndThrow("read_evaluation_manager_statistics")) && (
                            <Link to="/emp/eval_directManager_stat" className='link_inside_dropdown' ><span dir="rtl"  >احصائيات تقييم المدير المباشر</span></Link>
                          )}


                          {(checkPermissionAndThrow("read_evaluation_settings")) && (
                            <Link to="/emp/eval_settings" className='link_inside_dropdown' ><span dir="rtl"  >اعدادات التقييم</span></Link>
                          )}


                          {(checkPermissionAndThrow("create_evaluations")) && (
                            <Link to="/emp/eval_start_testperiod_requests" className='link_inside_dropdown' ><span dir="rtl"  >بدء تقييم الفترة التجريبية </span></Link>
                          )}

                          <span className='link_inside_dropdown btn_navbar' onClick={() => { handleExportEvalExcelFile() }} ><span dir="rtl"  >التصدير الى ملف اكسل</span></span>

                        </>
                      }
                    />
                  )}


                {/* القضايا التأديبية — disciplinary module (shown to any role with disciplinary access) */}
                {(checkPermissionAndThrow("read_disciplinary_cases") || checkPermissionAndThrow("create_disciplinary_cases")
                  || checkPermissionAndThrow("department_head_review_disciplinary_cases") || checkPermissionAndThrow("factory_manager_review_disciplinary_cases")
                  || checkPermissionAndThrow("hr_review_disciplinary_cases") || checkPermissionAndThrow("read_disciplinary_rules")
                  || checkPermissionAndThrow("read_violation_types") || checkPermissionAndThrow("read_penalty_types")
                  || checkPermissionAndThrow("read_work_schedules") || checkPermissionAndThrow("read_factories")) && (
                    <Dropdown
                      buttonText="العقوبات التأديبية"
                      content={
                        <>
                          {(checkPermissionAndThrow("read_disciplinary_cases") || checkPermissionAndThrow("create_disciplinary_cases")
                            || checkPermissionAndThrow("department_head_review_disciplinary_cases") || checkPermissionAndThrow("factory_manager_review_disciplinary_cases")
                            || checkPermissionAndThrow("hr_review_disciplinary_cases")) && (
                              <Link to="/emp/disciplinary_cases" className='link_inside_dropdown'><span dir="rtl"  >القضايا التأديبية</span></Link>
                            )}

                          {(checkPermissionAndThrow("read_disciplinary_objections") || checkPermissionAndThrow("review_disciplinary_objections")
                            || checkPermissionAndThrow("hr_review_disciplinary_cases")) && (
                              <Link to="/emp/disciplinary-objections" className='link_inside_dropdown'><span dir="rtl"  >الاعتراضات</span></Link>
                            )}

                          {(checkPermissionAndThrow("read_disciplinary_statistics") || checkPermissionAndThrow("hr_review_disciplinary_cases")
                            || checkPermissionAndThrow("read_disciplinary_cases")) && (
                              <Link to="/emp/disciplinary-statistics" className='link_inside_dropdown'><span dir="rtl"  >الإحصائيات</span></Link>
                            )}

                          {(checkPermissionAndThrow("read_disciplinary_rules")) && (
                            <Link to="/emp/disciplinary_rules" className='link_inside_dropdown'><span dir="rtl"  >ربط العقوبات بالمخالفة</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_violation_types")) && (
                            <Link to="/emp/violations" className='link_inside_dropdown'><span dir="rtl"  >إدارة المخالفات</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_penalty_types")) && (
                            <Link to="/emp/penalty-types" className='link_inside_dropdown'><span dir="rtl"  >إدارة العقوبات</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_work_schedules")) && (
                            <Link to="/emp/work-schedules" className='link_inside_dropdown'><span dir="rtl"  >أوقات الدوام</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_factories")) && (
                            <Link to="/emp/factories" className='link_inside_dropdown'><span dir="rtl"  >إدارة المصانع</span></Link>
                          )}
                        </>
                      }
                    />
                  )}


                {(
                  checkPermissionAndThrow("read_users") || checkPermissionAndThrow("read_departments")
                  || checkPermissionAndThrow("read_job_positions") || checkPermissionAndThrow("read_penalties") || checkPermissionAndThrow("read_roles")
                  || checkPermissionAndThrow("read_relatives") || checkPermissionAndThrow("read_health_insurance_categories") || checkPermissionAndThrow("read_health_insurance_procedures")
                  || checkPermissionAndThrow("read_health_insurance_category_procedure") || checkPermissionAndThrow("read_medical_centers") || checkPermissionAndThrow("read_bills_statistics")
                  || checkPermissionAndThrow("update_penalties") || checkPermissionAndThrow("update_insurances") || checkPermissionAndThrow("update_users")
                  || checkPermissionAndThrow("update_departments") || checkPermissionAndThrow("update_papers") || checkPermissionAndThrow("update_job_positions")
                  || checkPermissionAndThrow("update_relatives")
                  || checkPermissionAndThrow("import_salaries") || checkPermissionAndThrow("delete_users") || checkPermissionAndThrow("delete_relatives") || checkPermissionAndThrow("delete_vacations")
                  || checkPermissionAndThrow("read_vacation_statistics")

                ) && (

                    <Dropdown
                      buttonText="الادارة"
                      content={
                        <>
                          {(checkPermissionAndThrow("create_users")) && (
                            <Link to="/emp/addNewUser" className='link_inside_dropdown'><span dir="rtl">انشاء موظف</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_users")) && (
                            <Link to="/emp/empmang" className='link_inside_dropdown'><span dir="rtl">ادارة الموظفين</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_relatives") || checkPermissionAndThrow("read_health_insurance_categories")
                            || checkPermissionAndThrow("read_health_insurance_procedures")
                            || checkPermissionAndThrow("read_health_insurance_category_procedure")
                            || checkPermissionAndThrow("read_medical_centers")
                            || checkPermissionAndThrow("read_bills_statistics")) && (
                              <Link to="/emp/h_insurance_managment_main_page" className='link_inside_dropdown'><span dir="rtl">ادارة التأمين الصحي</span></Link>
                            )}

                          {(checkPermissionAndThrow("read_vacation_statistics") || checkPermissionAndThrow("delete_vacations")) && (
                            <Link to="/emp/vaca_stat" className='link_inside_dropdown'><span dir="rtl"  >احصائيات الاجازات</span></Link>
                          )}

                          {(checkPermissionAndThrow("read_vacation_statistics")) && (
                            <Link to="/emp/exist_per_stat" className='link_inside_dropdown'><span dir="rtl"  >احصائيات اذونات الخروج</span></Link>
                          )}

                          {
                            (checkPermissionAndThrow("hr_manager")) &&
                            (
                              (checkPermissionAndThrow("door_officer")) && (
                                <Link to="/emp/exist_per_guards" className='link_inside_dropdown'><span dir="rtl"  >اذونات الخروج</span></Link>

                              ))}

                          {(checkPermissionAndThrow("read_departments")) && (
                            <Link to="/emp/mang_deps" className='link_inside_dropdown'><span dir="rtl"  >ادارة الاقسام</span></Link>

                          )}

                          {(checkPermissionAndThrow("read_job_positions")) && (
                            <Link to="/emp/mang_job_positions" className='link_inside_dropdown'><span dir="rtl"  >ادارة المناصب الوظيفية</span></Link>

                          )}

                          {/* "ادارة العقوبات" moved to the dedicated top-level "العقوبات التأديبية" menu — avoids a duplicate entry */}
                          {/* {(checkPermissionAndThrow("read_penalties")) && (
                            <Link to="/emp/punshments_hr" className='link_inside_dropdown'><span dir="rtl"  >ادارة العقوبات</span></Link>

                          )} */}

                          {(checkPermissionAndThrow("read_roles")) && (
                            <Link to="/emp/manage_roles" className='link_inside_dropdown'><span dir="rtl"  >ادارة الصلاحيات</span></Link>

                          )}


                          {(checkPermissionAndThrow("delete_users")) && (
                            <Link to="/emp/archives_show" className='link_inside_dropdown'><span dir="rtl"  >ادارة الأرشيف</span></Link>

                          )}

                          {(checkPermissionAndThrow("import_salaries") || checkPermissionAndThrow("update_users") || checkPermissionAndThrow("update_job_positions")
                            || checkPermissionAndThrow("update_papers") || checkPermissionAndThrow("update_insurances") || checkPermissionAndThrow("update_departments")
                            || checkPermissionAndThrow("update_relatives")) && (
                              <Link to="/emp/uploadfiles" className='link_inside_dropdown'><span dir="rtl"  >رفع الملفات</span></Link>

                            )}


                        </>
                      }
                    />

                  )}

                {
                  (authMe?.is_manager ||
                    authMe?.department?.manager?.job_id === authMe?.job_id)
                  &&
                  (
                    <Dropdown
                      buttonText="القسم"
                      content={
                        <>
                          <Link to="/emp/departmentemps" className='link_inside_dropdown'><span dir="rtl"  >موظفيين القسم</span></Link>
                          <Link to="/emp/departmentemps_vecation" className='link_inside_dropdown'><span dir="rtl"  >إجازات القسم</span></Link>
                          {
                            (!checkPermissionAndThrow("change_vacation_status")) &&
                            (
                              <Link to="/emp/vacationmang" className='link_inside_dropdown'><span dir="rtl"  >طلبات الاجازة</span></Link>
                            )
                          }


                        </>
                      }
                    />
                  )
                }


                {
                  (checkPermissionAndThrow("factory_manager_review_disciplinary_cases"))

                  &&
                  (
                    <Dropdown
                      buttonText="المصنع"
                      content={
                        <>
                          <Link to="/emp/factoryemps" className='link_inside_dropdown'><span dir="rtl"  >موظفين المصنع</span></Link>




                        </>
                      }
                    />
                  )
                }


                {
                  (checkPermissionAndThrow("change_vacation_status")) && (
                    <Link to="/emp/vacations_hr_show" className='nav_links_white'>طلبات الاجازة</Link>

                  )}



                {
                  (!checkPermissionAndThrow("hr_manager")) &&
                  (
                    (checkPermissionAndThrow("door_officer")) && (
                      <Link to="/emp/exist_per_guards" className='nav_links_white'>أذونات الخروج</Link>

                    ))}


                <Link to="/emp/vacationreq" className='nav_links_white' >طلب اجازة</Link>

                <Link to="/emp/eval_emp" className='nav_links_white' >التقييم و المتابعة</Link>

                <Link to="/emp/salarypage" className='nav_links_white' >الراتب</Link>

                <NotificationBell />

                <Dropdown
                  buttonText={handleGetFullEmpName()}
                  content={
                    <>
                      <Link to="/emp" className='link_inside_dropdown'><span dir="rtl"  >الصفحة الرئيسية</span></Link>
                      <Link to="/emp/change_pass" className='link_inside_dropdown'><span dir="rtl"  >تغيير كلمة المرور </span></Link>

                      {
                        (checkHiringDateBiggerThanSixMonthes(authMe)) &&
                        (<Link to="/emp/h_insurance_personal_data" className='link_inside_dropdown'><span dir="rtl"  >التأمين الصحي  </span></Link>)
                      }

                      {/* <Link to="/emp" className='link_inside_dropdown'><span dir="rtl"  >تحميل تطبيق الأندرويد </span></Link> */}

                      <span onClick={(e) => { handelLogOut(e) }} className='span_text_in_NavBar link_inside_dropdown' >تسجيل الخروج</span>
                    </>
                  }
                />

              </div>

              <div className='small_navbar' ref={sideNavRef} >

                <div className='small_navbar_icon_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }}>

                  <div className='menuIcon_item'></div>
                  <div className='menuIcon_item'></div>
                  <div className='menuIcon_item menuIcon_last_item'></div>

                </div>


                <div className={openNavIcon ? "menu active" : "menu"} >

                  <div className="itemInside_menu">
                    <Link
                      to="/emp/nofications"
                      className='nav_links_white'
                      onClick={() => { setOpenNavIcon(!openNavIcon); }}
                    >
                      الإشعارات
                    </Link>
                  </div>

                  <div className="itemInside_menu">

                    <Dropdown

                      buttonText={handleGetFullEmpName()}
                      content={
                        <>
                          <Link to="/emp" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl" >الصفحة الرئيسية</span></Link>
                          <Link to="/emp/change_pass" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }}><span dir="rtl"  >تغيير كلمة المرور </span></Link>

                          {
                            (checkHiringDateBiggerThanSixMonthes(authMe)) &&
                            (<Link to="/emp/h_insurance_personal_data" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }}><span dir="rtl"  > التأمين الصحي</span></Link>)
                          }

                          {/* <Link to="/emp" className='link_inside_dropdown'><span dir="rtl"  >تحميل تطبيق الأندرويد </span></Link> */}

                          <span onClick={(e) => { handelLogOut(e) }} className='span_text_in_NavBar link_inside_dropdown' >تسجيل الخروج</span>

                        </>
                      }
                    />

                  </div>

                  <Link to="/emp/salarypage" className='nav_links_white itemInside_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }} >الراتب</Link>


                  <Link to="/emp/eval_emp" className='nav_links_white itemInside_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }} >التقييم و المتابعة</Link>

                  <Link to="/emp/vacationreq" className='nav_links_white itemInside_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }} >طلب اجازة</Link>



                  {
                    (checkPermissionAndThrow("change_vacation_status")) && (
                      <Link to="/emp/vacations_hr_show" className='nav_links_white itemInside_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }}>طلبات الاجازة</Link>

                    )}

                  {/* <Link to="/emp/whate_insurance" className='nav_links_white itemInside_menu ' >ماهو التأمين الصحي  </Link> */}


                  {
                    (!checkPermissionAndThrow("hr_manager")) &&
                    (
                      (checkPermissionAndThrow("door_officer")) && (
                        <Link to="/emp/exist_per_guards" className='nav_links_white itemInside_menu' onClick={() => { setOpenNavIcon(!openNavIcon); }}>أذونات الخروج</Link>

                      ))}




                  {
                    (authMe?.is_manager ||
                      authMe?.department?.manager?.job_id === authMe?.job_id)
                    &&
                    (
                      <div className="itemInside_menu" >

                        <Dropdown
                          buttonText="القسم"
                          content={
                            <>
                              <Link to="/emp/departmentemps" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >موظفيين القسم</span></Link>

                              {
                                (!checkPermissionAndThrow("change_vacation_status")) &&
                                (
                                  <Link to="/emp/vacationmang" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >طلبات الاجازة</span></Link>
                                )
                              }

                            </>
                          }
                        />

                      </div>

                    )
                  }

                  {
                    true
                    &&
                    (
                      <div className="itemInside_menu" >

                       
                {
                  (checkPermissionAndThrow("factory_manager_review_disciplinary_cases"))

                  &&
                  (
                    <Dropdown
                      buttonText="المصنع"
                      content={
                        <>
                          <Link to="/emp/factoryemps" className='link_inside_dropdown'><span dir="rtl"  >موظفين المصنع</span></Link>




                        </>
                      }
                    />
                  )
                }

                      </div>

                    )
                  }


                  {/* القضايا التأديبية — mobile disciplinary menu (single entry, mirrors desktop) */}
                  {(checkPermissionAndThrow("read_disciplinary_cases") || checkPermissionAndThrow("create_disciplinary_cases")
                    || checkPermissionAndThrow("department_head_review_disciplinary_cases") || checkPermissionAndThrow("factory_manager_review_disciplinary_cases")
                    || checkPermissionAndThrow("hr_review_disciplinary_cases") || checkPermissionAndThrow("read_disciplinary_rules")
                    || checkPermissionAndThrow("read_violation_types") || checkPermissionAndThrow("read_penalty_types")
                    || checkPermissionAndThrow("read_work_schedules") || checkPermissionAndThrow("read_factories")) && (

                      <div className="itemInside_menu" >

                        <Dropdown
                          buttonText="العقوبات التأديبية"
                          content={
                            <>
                              {(checkPermissionAndThrow("read_disciplinary_cases") || checkPermissionAndThrow("create_disciplinary_cases")
                                || checkPermissionAndThrow("department_head_review_disciplinary_cases") || checkPermissionAndThrow("factory_manager_review_disciplinary_cases")
                                || checkPermissionAndThrow("hr_review_disciplinary_cases")) && (
                                  <Link to="/emp/disciplinary_cases" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >القضايا التأديبية</span></Link>
                                )}

                              {(checkPermissionAndThrow("read_disciplinary_objections") || checkPermissionAndThrow("review_disciplinary_objections")
                                || checkPermissionAndThrow("hr_review_disciplinary_cases")) && (
                                  <Link to="/emp/disciplinary-objections" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >الاعتراضات</span></Link>
                                )}

                              {(checkPermissionAndThrow("read_disciplinary_statistics") || checkPermissionAndThrow("hr_review_disciplinary_cases")
                                || checkPermissionAndThrow("read_disciplinary_cases")) && (
                                  <Link to="/emp/disciplinary-statistics" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >الإحصائيات</span></Link>
                                )}

                              {(checkPermissionAndThrow("read_disciplinary_rules")) && (
                                <Link to="/emp/disciplinary_rules" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >ربط العقوبات بالمخالفة</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_violation_types")) && (
                                <Link to="/emp/violations" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >إدارة المخالفات</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_penalty_types")) && (
                                <Link to="/emp/penalty-types" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >إدارة العقوبات</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_work_schedules")) && (
                                <Link to="/emp/work-schedules" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >أوقات الدوام</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_factories")) && (
                                <Link to="/emp/factories" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >إدارة المصانع</span></Link>
                              )}
                            </>
                          }
                        />

                      </div>

                    )}


                  {(
                    checkPermissionAndThrow("read_users") || checkPermissionAndThrow("read_departments")
                    || checkPermissionAndThrow("read_job_positions") || checkPermissionAndThrow("read_penalties") || checkPermissionAndThrow("read_roles")
                    || checkPermissionAndThrow("read_relatives") || checkPermissionAndThrow("read_health_insurance_categories") || checkPermissionAndThrow("read_health_insurance_procedures")
                    || checkPermissionAndThrow("read_health_insurance_category_procedure") || checkPermissionAndThrow("read_medical_centers") || checkPermissionAndThrow("read_bills_statistics")
                    || checkPermissionAndThrow("update_penalties") || checkPermissionAndThrow("update_insurances") || checkPermissionAndThrow("update_users")
                    || checkPermissionAndThrow("update_papers") || checkPermissionAndThrow("update_departments") || checkPermissionAndThrow("update_job_positions")
                    || checkPermissionAndThrow("update_relatives")
                    || checkPermissionAndThrow("import_salaries") || checkPermissionAndThrow("delete_users") || checkPermissionAndThrow("delete_relatives") || checkPermissionAndThrow("delete_vacations")
                    || checkPermissionAndThrow("read_vacation_statistics")
                  ) && (

                      <div className="itemInside_menu" >

                        <Dropdown
                          buttonText="الادارة"
                          content={
                            <>
                              {(checkPermissionAndThrow("create_users")) && (
                                <Link to="/emp/addNewUser" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl">انشاء موظف</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_users")) && (
                                <Link to="/emp/empmang" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl">ادارة الموظفين</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_relatives") || checkPermissionAndThrow("read_health_insurance_categories")
                                || checkPermissionAndThrow("read_health_insurance_procedures")
                                || checkPermissionAndThrow("read_health_insurance_category_procedure")
                                || checkPermissionAndThrow("read_medical_centers")
                                || checkPermissionAndThrow("read_bills_statistics")) && (
                                  <Link to="/emp/h_insurance_managment_main_page" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl">ادارة التأمين الصحي</span></Link>
                                )}

                              {(checkPermissionAndThrow("read_vacation_statistics") || checkPermissionAndThrow("delete_vacations")) && (
                                <Link to="/emp/vaca_stat" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >احصائيات الاجازات</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_vacation_statistics")) && (
                                <Link to="/emp/exist_per_stat" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >احصائيات اذونات الخروج</span></Link>
                              )}

                              {
                                (checkPermissionAndThrow("hr_manager")) &&
                                (
                                  (checkPermissionAndThrow("door_officer")) && (
                                    <Link to="/emp/exist_per_guards" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >اذونات الخروج</span></Link>

                                  ))}

                              {(checkPermissionAndThrow("read_departments")) && (
                                <Link to="/emp/mang_deps" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >ادارة الاقسام</span></Link>

                              )}

                              {(checkPermissionAndThrow("read_job_positions")) && (
                                <Link to="/emp/mang_job_positions" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >ادارة المناصب الوظيفية</span></Link>

                              )}

                              {/* "ادارة العقوبات" moved to the dedicated "العقوبات التأديبية" mobile menu — avoids a duplicate entry */}

                              {(checkPermissionAndThrow("read_roles")) && (
                                <Link to="/emp/manage_roles" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >ادارة الصلاحيات</span></Link>

                              )}

                              {(checkPermissionAndThrow("delete_users")) && (
                                <Link to="/emp/archives_show" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >ادارة الأرشيف</span></Link>

                              )}

                              {(checkPermissionAndThrow("import_salaries") || checkPermissionAndThrow("update_users") || checkPermissionAndThrow("update_job_positions")
                                || checkPermissionAndThrow("update_papers") || checkPermissionAndThrow("update_insurances") || checkPermissionAndThrow("update_departments")
                                || checkPermissionAndThrow("update_relatives")) && (
                                  <Link to="/emp/uploadfiles" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >رفع الملفات</span></Link>

                                )}


                            </>
                          }
                        />

                      </div>


                    )}



                  {(checkPermissionAndThrow("create_evaluations") || checkPermissionAndThrow("read_evaluations") || checkPermissionAndThrow("update_evaluations")
                    || checkPermissionAndThrow("read_evaluation_settings") || checkPermissionAndThrow("read_manager_evaluations")
                    || checkPermissionAndThrow("hr_manager") || checkPermissionAndThrow("read_evaluation_statistics")
                    || checkPermissionAndThrow("read_evaluation_manager_statistics") || authMe?.is_manager) &&
                    (

                      <div className="itemInside_menu lastItemInside_menu" >

                        <Dropdown
                          buttonText="التقييم"
                          content={
                            <>
                              {(authMe?.is_manager || checkPermissionAndThrow("hr_manager") || checkPermissionAndThrow("read_evaluations") || checkPermissionAndThrow("update_evaluations")) && (
                                <Link to="/emp/eval_emp_manager" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >التقييم</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_evaluation_statistics")) && (
                                <Link to="/emp/eval_stat_main_page_show" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >احصائيات تقييم الموظفين</span></Link>
                              )}

                              {(checkPermissionAndThrow("read_evaluation_manager_statistics")) && (
                                <Link to="/emp/eval_directManager_stat" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >احصائيات تقييم المدير المباشر</span></Link>
                              )}


                              {(checkPermissionAndThrow("read_evaluation_settings")) && (
                                <Link to="/emp/eval_settings" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >اعدادات التقييم</span></Link>
                              )}


                              {(checkPermissionAndThrow("create_evaluations")) && (
                                <Link to="/emp/eval_start_testperiod_requests" className='link_inside_dropdown' onClick={() => { setOpenNavIcon(!openNavIcon); }} ><span dir="rtl"  >بدء تقييم الفترة التجريبية </span></Link>
                              )}

                              <span className="link_inside_dropdown btn_navbar" onClick={() => { handleExportEvalExcelFile() }} ><span dir="rtl"  >التصدير الى ملف اكسل</span></span>

                            </>
                          }
                        />

                      </div>




                    )}


                </div>

              </div>

            </div>
          )
          :
          (
            <></>
          )
      }

      <div className="navbar_right" onClick={() => { onIconClick() }}>
        <span>مجموعة المتين</span>
        <img src={almatin_img} alt="almatin_image" className='navbar_image' />
      </div>
    </div>
  )
}

export default Navbar